import React, {useRef} from 'react';
import { useDrop } from 'react-dnd'
import {IProps} from './types';
import * as S from './styles';

const DropFolder:React.FC<IProps> = ({onDrop, children, index, disabled, selectedFolder}) => {

  const [{ isOver, isOverCurrent }, drop] = useDrop({
    accept:"DESIGN",
    drop(item: unknown, monitor) {
      if (onDrop) onDrop(index, item);
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      isOverCurrent: monitor.isOver({ shallow: true })
    }),
  })
  
  return (
    <S.Root 
    ref={drop}
    role="Dustbin"
    disabled={disabled}
    bgHover={isOverCurrent && index>1 ? 'rgba(32, 64, 120, 0.15)' : selectedFolder ? 'rgba(32, 64, 120, 0.05)': '' }
    >
       {children}
    </S.Root>
  );
}

export default DropFolder;